import { ScrollView, _decorator, UITransform } from 'cc';
import BaseAutoHiding from './BaseAutoHiding';

const { ccclass, requireComponent, executeInEditMode } = _decorator;

@ccclass('AutoHidingScrollView')
@requireComponent(ScrollView)
@executeInEditMode
export default class AutoHidingScrollView extends BaseAutoHiding {
    private _scrollView: ScrollView = null;

    protected get viewUTransform(): UITransform {
        return this.scrollView.view;
    }

    protected get allItemRoots() {
        return [...super.allItemRoots, this.scrollView.content];
    }

    private get scrollView() {
        if (!this._scrollView) {
            this._scrollView = this.getComponent(ScrollView);
        }
        return this._scrollView;
    }
}
